<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="12"
          >
            <v-autocomplete
              v-model="product"
              :items="products"
              item-text="name"
              hide-details="auto"
              return-object
              outlined
              chips
              label="Select Product"
              @change="loadSupplier"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="12"
          >
            <v-autocomplete
              v-model="supplier"
              :items="suppliers"
              item-text="firstName"
              hide-details="auto"
              return-object
              outlined
              chips
              label="Select Supplier"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row v-if="product">
      <v-col
        cols="12"
        md="8"
        sm="4"
      >
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Product Name
                </th>
                <th class="text-left">
                  Barcode
                </th>
                <th class="text-left">
                  SKU
                </th>
                <th class="text-left">
                  Avl Qty
                </th>
                <th class="text-left">
                  Unit Cost
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="active">
                <td>{{ product.name }}</td>
                <td>{{ product.barcode }}</td>
                <td>{{ product.sku }}</td>
                <td>{{ product.qty }}</td>
                <td>{{ product.cost | currency }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="order.cost"
              hide-details="auto"
              label="Unit Cost"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="order.totalItems"
              hide-details="auto"
              label="Total Items"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-card
          outlined
          class="mt-4 px-0"
        >
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total QTY:</td>
                    <td>{{ order.totalItems }}</td>
                  </tr>
                  <tr>
                    <td>Total:</td>
                    <td>{{ subTotal | currency }}</td>
                  </tr>
                  <tr>
                    <td>After Discount (-){{ discountedAmount }}:</td>
                    <td>
                      {{ afterDiscount | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>With Tax (+){{ taxAmount }}:</td>
                    <td>
                      {{ withTax | currency }}
                    </td>
                  </tr>
                  <tr>
                    <th>Total Amount (Payable):</th>
                    <td>
                      {{ totalAmount | currency }}
                    </td>
                  </tr>

                  <tr>
                    <td>Excluded Shipping:</td>
                    <td>
                      {{ order.shippingAmount | currency }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
      >
        <v-card outlined>
          <v-card-text>
            <v-checkbox
              v-model="order.method"
              class="ml-6"
              :label="order.method ? 'On credit' : 'With cash'"
            />
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.reference"
                hide-details="auto"
                label="Reference"
                outlined
                dense
              />
            </v-col>
            <v-col
              v-if="order.method"
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.dueDate"
                hide-details="auto"
                label="Due Date"
                outlined
                type="date"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.discountRate"
                hide-details="auto"
                label="Discounted Rate %"
                outlined
                type="number"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.taxRate"
                hide-details="auto"
                label="Tax Rate %"
                outlined
                type="number"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.shippingAmount"
                hide-details="auto"
                label="Shipping Charges"
                outlined
                type="number"
                dense
              />
            </v-col>
          </v-card-text>
        </v-card>
        <div class="text-center">
          <v-btn
            color="green"
            class="ma-2 white--text"
            :disabled="!order.cost || !order.totalItems"
            @click="createPurchase"
          >
            Save
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            :to="{ name: 'PurchaseTransaction' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      products: [],
      product: {},
      suppliers: [],
      supplier: {},
      order: {
        purchasing: true,
        totalItems: 0,
        method: false,
        shippingAmount: 0,
        taxRate: 0,
        subTotal: 0,
        dueDate: new Date().toISOString().substr(0, 10),
        reference: new Date(),
        discountRate: 0,
      },
    };
  },
  computed: {
    subTotal() {
      return this.$data.order.totalItems * this.$data.order.cost;
    },
    discountedAmount() {
      let discountRate = this.$data.order.discountRate ?? 0;
      return this.subTotal * (discountRate / 100);
    },
    taxAmount() {
      let taxRate = this.$data.order.taxRate ?? 0;
      let amount = this.subTotal ?? 0;
      return amount * (taxRate / 100);
    },
    afterDiscount() {
      return this.subTotal - this.discountedAmount;
    },
    withTax() {
      return this.afterDiscount + this.taxAmount;
    },
    totalAmount() {
      return this.withTax;
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    prepairData() {
      this.$data.order.supplier_id = this.$data.supplier.id;
      this.$data.order.subTotal = this.subTotal;
      this.$data.order.discountedAmount = this.discountedAmount;
      this.$data.order.taxAmount = this.taxAmount;
      this.$data.order.totalAmount = this.totalAmount;
      this.$data.product.subTotal = this.subTotal;
      this.$data.order.items = [this.$data.product];
      return this.$data.order;
    },
    createPurchase() {
      window.axios.post("/purchase", this.prepairData()).then((response) => {
        this.feedback(response.data.message);
        this.$router.push({
          name: "PrintPurchase",
          params: { id: response.data.id },
        });
      });
    },
    getFromApi() {
      window.axios.get("/product-form-data").then((response) => {
        this.products = response.data.products;
      });
    },
    loadSupplier() {
      window.axios.get("/product/" + this.$data.product.id).then((response) => {
        this.$data.suppliers = response.data.suppliers;
      });
    },
  },
};
</script>
